import * as React from "react"
import { Slot } from "@radix-ui/react-slot"
import { cva } from "class-variance-authority";

import { cn } from "@/lib/utils"

const buttonVariants = cva(
  "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0",
  {
    variants: {
      variant: {
        default:
          "bg-primary text-primary-foreground shadow hover:bg-primary/90",
        destructive:
          "bg-destructive text-destructive-foreground shadow-sm hover:bg-destructive/90",
        outline:
          "border border-input shadow-sm hover:bg-accent hover:text-accent-foreground",
        secondary:
          "bg-secondary text-secondary-foreground shadow-sm hover:bg-secondary/80",
        /* R-3 (remate smoke-2) — LA VARIANTE FANTASMA, QUE ES LA DEL BOTE DE BASURA.
           `ghost` no pinta nada hasta que algo la toca: TODO su aspecto es el hover. En un
           aparato táctil eso la vuelve el peor caso del hover pegado — el fondo `accent`
           (#1f1f1f) se queda puesto sobre el ícono que el dedo rozó de pasada, y en el
           Panel ese ícono es el de BORRAR, que no pide confirmación. Pasa a `hoverable:`
           (misma regla dentro de `@media (hover: hover)`, ver tailwind.config.js): en la
           laptop, carácter por carácter lo de hoy; en el teléfono, nada que se pegue.
           Las otras cinco variantes NO se tocan: pintan solas y su hover es un matiz. */
        ghost: "hoverable:bg-accent hoverable:text-accent-foreground",
        link: "text-primary underline-offset-4 hover:underline",
      },
      size: {
        default: "h-9 px-4 py-2",
        sm: "h-8 rounded-md px-3 text-xs",
        lg: "h-10 rounded-md px-8",
        icon: "h-9 w-9",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  }
)

const Button = React.forwardRef(({ className, variant, size, asChild = false, ...props }, ref) => {
  const Comp = asChild ? Slot : "button"
  return (
    <Comp
      className={cn(buttonVariants({ variant, size, className }))}
      ref={ref}
      {...props} />
  );
})
Button.displayName = "Button"

export { Button, buttonVariants }
